import CodeButtons from '@components/code_buttons';
import { ReactComponent as ViewOnGitHub } from '@assets/images/imgly/view_on_github.svg';
import { ReactComponent as EditOnCodeSandbox } from '@assets/images/imgly/edit_on_codesandbox.svg';
import * as React from 'react';
export default {
  CodeButtons,
  ViewOnGitHub,
  EditOnCodeSandbox,
  React
};